export const zIndices = Object.freeze({
  card: '10',
  navbar: '100',
  fab: '9000',
  modal: '10000',
  dropdown: '11000',
  tooltip: '12000',
} as const);
